//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import { Box      } from '@mui/material';

// === COMPONENTS ===
import { TaskProvider      } from './components/TaskContext/TaskContext';
import { TaskPanel         } from './components/TaskPanel/index';
import { TaskCompleteModal } from './components/TaskCompleteModal';
import { TaskDashboard } from './components/TaskDashboard/index';

//#endregion

//-----------------------------------------------------------------
export function TaskVerification() {
  //-----------------------------------------------------------------

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    container: {
      height: `calc(100% - 5rem)`,
      overflow  : 'hidden',
      'z-index' : '0',
      backgroundColor : theme.palette.background.secondary[theme.palette.mode],
    },
  }

  const
    CONTAINER = {
      sx: _styles.container,
    };

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    
    return (
      <Box { ...CONTAINER }>
        <TaskProvider>
          <TaskDashboard     />
          <TaskPanel         />
          <TaskCompleteModal />
        </TaskProvider>
      </Box>
    )
  }

  //#endregion

  return display();
}
